<template>
    <v-container fluid px-3 pt-3>
        <v-row row wrap>
            <v-col cols="12">
                <h3>Death Verification</h3>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row row wrap>
            <v-col>
                <v-card>
                    <v-form v-model="formValid" ref="deathVerForm">
                        <v-container>
                            <v-row v-if="!insuranceUser">
                                <v-col cols="3">
                                    <v-text-field label="First Name" v-model="deathVerificationDto.firstName" required :rules="[ruleFunction]"></v-text-field>
                                </v-col>
                                <v-col cols="3">
                                    <v-text-field label="Middle Name" v-model="deathVerificationDto.middleName" persistent-hint hint="Optional"></v-text-field>
                                </v-col>
                                <v-col cols="3">
                                    <v-text-field label="Last Name" v-model="deathVerificationDto.lastName" required :rules="[ruleFunction]"></v-text-field>
                                </v-col>
                                <v-col cols="3">
                                    <v-text-field label="Date of Birth" validate-on-blur type="date" v-model="deathVerificationDto.dateOfBirth" required :rules="[ruleFunction]">
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row v-if="insuranceUser">
                                <v-col cols="4">
                                    <v-text-field label="First Name" v-model="deathInsuranceVerificationDto.firstName" :rules="[insuranceRuleFunction]"></v-text-field>
                                </v-col>
                                <v-col cols="4">
                                    <v-text-field label="Middle Name" v-model="deathInsuranceVerificationDto.middleName" :persistent-hint="true" hint="Optional"></v-text-field>
                                </v-col>
                                <v-col cols="4">
                                    <v-text-field label="Last Name" v-model="deathInsuranceVerificationDto.lastName" :rules="[insuranceRuleFunction]"></v-text-field>
                                </v-col>
                                <v-col cols="5">
                                    <v-text-field label="Date of Birth" type="date" v-model="deathInsuranceVerificationDto.dateOfBirth"></v-text-field>
                                </v-col>
                                <v-col cols="1">
                                    OR
                                </v-col>
                                <v-col cols="5">
                                    <v-text-field label="SSN" persistent-hint hint="XXXXXXXXX - No Dashes or Spaces" v-model="deathInsuranceVerificationDto.socialSecurity"></v-text-field>
                                </v-col>
                                <v-col cols="1">
                                    OR
                                </v-col>
                                <v-col cols="12">
                                    Decendent's Residential Address:
                                    <addr id="mothersResidence" v-model="deathInsuranceVerificationDto.address" ref="addressRef"></addr>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="6">
                                    <!--<v-select label="Reason for Verification" v-model="deathVerificationDto.verificationReason"
                                        required :rules="requiredRule"
                                        :items="reasons">
                                    </v-select>-->
                                    <b>This verification is for government use only. Please enter in some information related to your request (Employee ID, Request ID, etc.)</b>
                                </v-col>
                                <v-col cols="6">
                                    <v-text-field label="Additional Information" v-model="verificationReasonExtraInfo" :rules="requiredRule" required></v-text-field>
                                </v-col>
                            </v-row>
                            <div v-if="errors.length > 0">
                                <v-row  v-for="error in errors" :key="error">
                                    <b style="color:red">{{error}}</b>
                                </v-row>
                            </div>
                            <v-row>
                                <v-col cols="12">
                                    <v-btn color="secondary" :disabled="isLoading || !formValid" @click="sendDeathVerification">
                                        SUBMIT
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </v-card>
            </v-col>
        </v-row>
        <div v-if="!!response && response.matchedRecords.length === 1">
            <v-row>
                <v-col>
                    <v-icon color="green">mdi-check-circle</v-icon>
                    <label>  Matched!</label>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-data-table :items="response.matchedRecords" :headers="headers" item-key="deathId">
                    </v-data-table>
                </v-col>
            </v-row>

            <v-row >
                <v-col cols="12">
                    If you would like a complete abstract for this request please contact VSS.
                </v-col>
                <v-col cols="12" v-show="abstractRequested">
                    An abstract has been requested, once approved you will see it in your inbox.
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="2">
                    <v-btn @click="contactVSSForAbstract" :disabled="abstractRequested">Request Abstract</v-btn>
                </v-col>
                <v-col cols="2">
                    <v-btn @click="printVerification" :disabled="isPrinting">Print</v-btn>
                </v-col>
            </v-row>
        </div>
        <div v-else-if="!!response && response.matchedRecords.length > 1">
            <v-row>
                <v-col>
                    <v-icon color="yellow">mdi-help-circle</v-icon>
                    <label>  Potential Matches</label>
                </v-col>
            </v-row>
            <v-row >
                <v-col cols="6">
                    There is more than one match for this request. Please contact VSS.
                </v-col>
            </v-row>
        </div>
        <div v-else-if="!!response && response.matchedRecords.length === 0">
            <v-row>
                <v-col>
                    <v-icon color="red">mdi-close-circle</v-icon>
                    <label>  Not Verified</label>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="6">
                    If you believe this to be an error you may contact VSS for a more refined search.
                </v-col>
            </v-row>
        </div>
        <contact-vss :operationType="operationType" :requestId="requestId" :modType="40" :numMatches="numberOfMatchedRecords"></contact-vss>
    </v-container>
</template>

<script>
import mailService from '@/services/mailService'
import verificationService from '@/services/verificationService'
import mediaService from '@/services/mediaService'
import userService from '@/services/userService'
import Addr from '@/components/Address'
import ContactVss from '@/components/ContactVss'

export default {
    components: {
        Addr,
        ContactVss
    },
    data: () => {
        return {
            isLoading: false,
            isPrinting: false,
            abstractRequested: false,
            deathVerificationDto: {
                firstName: '',
                middleName: '',
                lastName: '',
                dateOfBirth: '',
                matched: null,
                verificationReason: ''
            },
            deathInsuranceVerificationDto: {
                firstName: '',
                middleName: '',
                lastName: '',
                dateOfBirth: null,
                matched: null,
                verificationReason: '',
                address: {},
                socialSecurity: null
            },
            verificationReasonExtraInfo: '',
            headers: [
                { text: 'First Name', value: 'firstName' },
                { text: 'Middle Name', value: 'middleName' },
                { text: 'Last Name', value: 'lastName' },
                { text: 'Sex', value: 'sex' },
                { text: 'Date of Birth', value: 'dateOfBirth' },
                { text: 'Death Date', value: 'deathDate' }
            ],
            reasons: ['Reason 1'],
            menu: false,
            verificationSent: false,
            requiredRule: [v => !!v || 'Required', v => v.trim() !== '' || 'Invalid Input'],
            formValid: false,
            response: '',
            numberOfMatchedRecords: null,
            requestId: 0,
            errors: [],
            operationType: mailService.OperationEnum.Verification
        }
    },
    computed: {
        insuranceUser () {
            return userService.isDeathInsuranceUser()
        }
    },
    methods: {
        sendDeathVerification () {
            this.$refs.deathVerForm.validate()
            if (this.formValid) {
                this.errors = []
                this.isLoading = true
                this.deathVerificationDto.verificationReason += ' ' + this.verificationReasonExtraInfo
                this.deathInsuranceVerificationDto.verificationReason += ' ' + this.verificationReasonExtraInfo

                if (this.insuranceUser) {
                    var addressHasError = this.$refs.addressRef.checkFields()
                    if (addressHasError && this.deathInsuranceVerificationDto.socialSecurity == null && this.deathInsuranceVerificationDto.dateOfBirth == null) {
                        this.errors.push('One of Date of Birth, Address, or Social Security Number must be entered')
                        this.isLoading = false
                    } else {
                        this.deathInsuranceVerificationDto.address = this.$refs.addressRef.placeDTO
                        verificationService.deathInsuranceVerification(this.$http, this.deathInsuranceVerificationDto).then(result => {
                            if (result.data && !result.data.errorMessages) {
                                this.response = result.data
                                this.numberOfMatchedRecords = this.response.matchedRecords.length
                                this.requestId = result.data.requestId
                            } else {
                                this.errors = result.data.errorMessages
                            }
                            this.verificationSent = true
                            this.isLoading = false
                        })
                    }
                } else {
                    verificationService.deathVerification(this.$http, this.deathVerificationDto).then(result => {
                        if (result.data && !result.data.errorMessages) {
                            this.response = result.data
                            this.numberOfMatchedRecords = this.response.matchedRecords.length
                            this.requestId = result.data.requestId
                        } else {
                            this.errors = result.data.errorMessages
                        }
                        this.verificationSent = true
                        this.isLoading = false
                    })
                }
            }
        },
        contactVSSForAbstract () {
            verificationService.verificationRequestAbstract(this.$http, this.requestId)
            this.abstractRequested = true
        },
        printVerification () {
            this.isPrinting = true
            verificationService.verificationPrint(this.$http, this.requestId).then(response => {
                mediaService.fileToDownload(response, 'deathVerification_request' + this.requestId + '.pdf')
                this.isPrinting = false
            })
        },
        insuranceRuleFunction (v) {
            return this.insuranceUser && !!v ? true : 'Required'
        },
        ruleFunction (v) {
            return !this.insuranceUser && !!v ? true : 'Required'
        }
    }
}
</script>
